import catalogHoursGateAtom from "../catalog-hours-gate";
import categoriesAtom from "../categories";
import { createCategoriesItemOffersAtom } from "../create-categories-item-offers-atom";
import itemOffersAtom from "../item-offers";

/** Category id → sorted item offers for the DELIVERY menu. */
const categoriesItemOffersAtom = createCategoriesItemOffersAtom(
  categoriesAtom,
  itemOffersAtom,
  catalogHoursGateAtom,
);

export default categoriesItemOffersAtom;
